/**
 * CSFloat Market Checker
 *
 * CS:GO market checker; resources scoped to csfloat.com.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 5.16.0.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'jjicbefpemnphinccgikpdaagjebbnhg';
export const csfloat: ExtensionDefinition = {
  id: ID,
  name: "CSFloat Market Checker",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  requiredOrigin: 'https://csfloat.com',
  notes: "CS:GO market checker; resources scoped to csfloat.com.",
  signals: [
    { id: 'war-src-version-txt', kind: 'web-accessible-resource',
      description: 'Fetch src/version.txt, exposed only to https://csfloat.com.',
      weight: 1, run: () => probeFetch(ID, 'src/version.txt') },
  ],
};
